import Vue from 'vue'
import VueRouter from 'vue-router'
import User from '../views/User.vue'
import HomeContent from '../views/HomeContent.vue'
import Login from '../views/Login.vue'
import NewsInfo from '../views/NewsInfo.vue'
import News from '../views/News.vue'


Vue.use(VueRouter)


const router = new VueRouter({
  routes: [
    { path:'/', redirect:'/login'},
    { path: '/login', component: Login },
    { path: '/homecontent', component: HomeContent, redirect:'/user', 
      children:[
        { path: '/user', name: 'User', component: User },
        // { path: '/home', name: 'Home', component: Home },
        //  { path: '/chargingrecord', name: 'ChargingRecord', component: ChargingRecord },
        // { path: '/newsinfo', name: 'NewsInfo', component: NewsInfo },
        // { path: '/news', name: 'News', component: News }, 
      ]},
    
  ]
})

router.beforeEach((to,from,next)=>{
  if(to.path ==='/login') return next()
  const tokenStr =window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})
export default router
